require( './bootstrap' );

import LazyLoad from "vanilla-lazyload"

document.addEventListener(
    'DOMContentLoaded',
    function () {
        let myLazyLoad = new LazyLoad( {
            elements_selector: ".lazy-load"
        } );
    }
);
$(document).ready(function () {

    let header = $('.js_header');
    let headerTopDefault = 25;
    if ($(document).scrollTop() > headerTopDefault && $(window).width() > 992) {
        header.addClass('fixed').css('top', '0px');
    }

    $(document).scroll(function () {
        if ($(window).width() > 992) {
            let header = $('.js_header');
            let headerTop = parseInt(header.css('top'));
            let scrollStatus = $(document).scrollTop();

            if (scrollStatus <= headerTopDefault) {
                header.css('top', (headerTopDefault - scrollStatus) + 'px');
                header.removeClass('fixed');
            } else if (headerTop > 0) {
                headerTop = scrollStatus > headerTop ? 0 : headerTop - scrollStatus;
                header.css('top', headerTop + 'px');
                header.addClass('fixed');
            }
        }
    });

    $('.js-burdger').on('click', function() {
        $(this).toggleClass('is-active');
        $(this).next().slideToggle();
    });


    $(window).scroll(function () {
        let scrollPosition = $(window).scrollTop();
        let windowHeight = $(window).height();
        if (scrollPosition > windowHeight) {
            $('.js_up_btn').addClass('active');
        } else {
            $('.js_up_btn').removeClass('active');
        }
    });


    // back to top button
    $('.js_up_btn').click(function () {
        $('html, body').animate({ scrollTop: 0 }, 800);
    });
});

document.addEventListener("DOMContentLoaded", readyHTML);
function readyHTML() {
    adapt('768', ['#menu-header'], 'cover', '.top');
}
function toggle_class(togle_cover, click_element, add_class) {
    let cover = document.querySelectorAll(togle_cover);
    if (cover) {
        for (let i = 0; i < cover.length; i++) {
            let elem = cover[i].querySelector(click_element);
            if (elem) {
                elem.addEventListener('click', _toggle);
            }
        }
    }
    function _toggle() {
        this.parentNode.classList.toggle(add_class);
    }
}
function chek_active_and_add_class(chek_item, class_to_faind, add_class) {
    let cover = document.querySelectorAll(chek_item);
    if (cover) {
        for (let i = 0; i < cover.length; i++) {
            let elem = cover[i].querySelector(class_to_faind);
            if (elem) {
                cover[i].classList.toggle(add_class);
            }
        }
    }
}
function move_block(adaptWid, block_to_move, place_to_move) {
    window.addEventListener('resize', _move_resizewindow);
    let place_to = document.querySelector(place_to_move);
    let block_to = document.querySelector(block_to_move);
    if (block_to && place_to) {
        let block = block_to.querySelector('ul');
        let place = place_to.querySelector('ul');
        if (block) block.classList.add('block_to_move');
        if (place) place.classList.add('place_to_move');
    }
    let wid = window.innerWidth;
    _move_resizewindow();
    function _move_resizewindow() {
        wid = window.innerWidth;
        let activeItems;
        if (wid < adaptWid) {
            let activeLiBlock = block.querySelectorAll('li');
            let activeLiPlace = place.querySelectorAll('li');
            if (activeLiBlock) {

            }
            if (block && place) {
                place_to.insertBefore(block, place);
            }
        } else {
            if (block && place) {
                let block_replaced = place_to.querySelector('.block_to_move');
                if (block_replaced) block_to.appendChild(block_replaced);
            }
        }
    }
}
function scrollfunc() {

}
function adapt(adaptWid, menu, covertable, insert_adapt_menu) {
    window.addEventListener('resize', _resizewindow);
    window.addEventListener('scroll', scrollfunc);
    if (covertable && covertable != 'nocover') {
        _coverTable();
    }
    let body = document.querySelector('body');

    function _coverTable() {
        let table = document.querySelectorAll('table');
        for (let i = table.length - 1; i >= 0; i--) {
            let cover = document.createElement('div');
            cover.classList.add('cover-table');
            table[i].parentNode.insertBefore(cover, table[i]);
            cover.appendChild(table[i]);
        }
    }
    let adapt_menu = [];
    if (menu) {
        for (let l = 0; l < menu.length; l++) {
            adapt_menu[l] = document.querySelectorAll(menu[l]);
        }
    }
    let adapt_menu_cover = document.createElement('div');
    adapt_menu_cover.classList.add('cover-menu');
    body.appendChild(adapt_menu_cover);
    let gamburger = document.querySelector('.adapt-menu-icon');
    if (!gamburger) {
        let gamburger = document.createElement('div');
        gamburger.classList.add('adapt-menu-icon');
        gamburger.innerHTML = '<span class="line-white-menu"></span>\n<span class="line-white-menu"></span>\n<span class="line-white-menu"></span>\n';
    }
    let gamburger2 = document.querySelector('.show-menu-icon');
    if (!gamburger2) {
        //let gamburger2 = document.createElement('div');
        //gamburger2.classList.add('show-menu-icon');
    }
    let bgicon = document.querySelector('.icon-menu-bg');
    if (!bgicon) {
        let bgicon = document.createElement('div');
        bgicon.classList.add('icon-menu-bg');
    }
    let closemenu = document.querySelector('.menu-close-button');
    if (!closemenu) {
        let closemenu = document.createElement('div');
        closemenu.innerHTML = '<span class="line-white-menu"></span>\n<span class="line-white-menu"></span>\n<span class="line-white-menu"></span>\n';
        closemenu.classList.add('menu-close-button');
    }

    let menu_menu = document.querySelector(insert_adapt_menu);
    if (gamburger && adapt_menu) {
        if (menu_menu) {
            menu_menu.appendChild(gamburger);
        } else {
            // body.appendChild(gamburger);
        }


        gamburger.addEventListener('click', showmenu);
    }
    if (gamburger2 && adapt_menu) {
        body.appendChild(gamburger2);
        gamburger2.addEventListener('click', showmenu);
    }
    if (bgicon && adapt_menu) {
        body.appendChild(bgicon);
        bgicon.addEventListener('click', hidemenu);
    }
    if (closemenu && adapt_menu_cover) {
        adapt_menu_cover.appendChild(closemenu);
        closemenu.addEventListener('click', hidemenu);
    }
    if (adapt_menu_cover && adapt_menu) {
        for (let d = 0; d < adapt_menu.length; d++) {
            for (let f = 0; f < adapt_menu[d].length; f++) {
                adapt_menu_cover.appendChild(adapt_menu[d][f].cloneNode(true));
            }
        }
    }
    let elements = adapt_menu_cover.querySelectorAll('*');
    for (let e = 0; e < elements.length; e++) {
        elements[e].removeAttribute('id');
    }
    _resizewindow();
    function _resizewindow() {
        let wid = window.innerWidth;
        if (wid < adaptWid) {
            if (gamburger) { gamburger.addEventListener('click', showmenu); }
            if (gamburger2) { gamburger2.addEventListener('click', showmenu); }
            if (bgicon) { bgicon.addEventListener('click', showmenu); }
            if (closemenu) { closemenu.addEventListener('click', hidemenu); }
        } else {
            if (gamburger) { gamburger.removeEventListener('click', showmenu); gamburger.classList.remove('activeGamburger'); }
            if (gamburger2) { gamburger2.removeEventListener('click', showmenu); }
            if (adapt_menu_cover) { adapt_menu_cover.classList.remove('showmenu'); }
            if (closemenu) { closemenu.removeEventListener('click', hidemenu); }
            if (bgicon) {
                bgicon.classList.remove('showbg');
                bgicon.removeEventListener('click', showmenu);
            }
            if (body) {
                body.classList.remove('OverflowHiden');
            }
        }
    }
    function showmenu() {
        if (gamburger) {
            gamburger.removeEventListener('click', showmenu);
            gamburger.classList.add('activeGamburger');
            gamburger.addEventListener('click', hidemenu);
        }
        if (gamburger2) {
            gamburger2.removeEventListener('click', showmenu);
            gamburger2.addEventListener('click', hidemenu);
        }
        let scrolled = window.pageYOffset || document.documentElement.scrollTop;

        if (adapt_menu_cover) {
            adapt_menu_cover.classList.add('showmenu');
        }
        if (closemenu) {
            closemenu.addEventListener('click', hidemenu);
        }
        if (bgicon) {
            bgicon.classList.add('showbg');
            bgicon.addEventListener('click', showmenu);
        }
        if (body) {
            body.classList.add('OverflowHiden');
        }
    }
    function hidemenu() {
        if (gamburger) {
            gamburger.addEventListener('click', showmenu);
            gamburger.classList.remove('activeGamburger');
            gamburger.removeEventListener('click', hidemenu);
        }
        if (gamburger2) {
            gamburger2.addEventListener('click', showmenu);
            gamburger2.removeEventListener('click', hidemenu);
        }
        if (bgicon) {
            bgicon.classList.remove('showbg');
            bgicon.removeEventListener('click', showmenu);
        }
        if (closemenu) {
            closemenu.removeEventListener('click', hidemenu);
        }
        if (adapt_menu_cover) {
            adapt_menu_cover.classList.remove('showmenu');
        }
        if (body) {
            body.classList.remove('OverflowHiden');
        }
    }
}

// Сплит тестирование
$(".go_btn").click(function(){
    let data_count = $('#input-split').val();
    data_count = parseInt(data_count) + 1;
    $('#input-split').val(data_count);

    let ajaxurl = '/wp-admin/admin-ajax.php';
    let form = "#test-form";
    $.ajax({
        url: ajaxurl + "?action=split_function",
        type: 'POST',
        data: {'input-test' : $('#input-split').val()},
        success: function(data) {
            console.log("SUCCESS!");
        },
        error: function(data) {
            console.log("FAILURE");
        }
    });
});




jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ){
        this.addEventListener("touchstart", handle, { passive: true });
    }
};

!function(){"use strict";!function(){let e=document.getElementById("js_game");e&&function(){let t=e.getElementsByTagName("button")[0];t&&t.addEventListener("click",function n(){let i=document.createElement("iframe"),a=e.getAttribute("data-game");i.setAttribute("src",a);t.removeEventListener("click",n);e.innerHTML="";e.appendChild(i)})}()}()}();

jQuery(function($){
	$('#true_loadmore').click(function(){
		$(this).text('Загружаю...'); // изменяем текст кнопки, вы также можете добавить прелоадер
		let data = {
			'action': 'loadmore',
			'query': true_posts,
			'page' : current_page
		};
		$.ajax({
			url:ajaxurl, // обработчик
			data:data, // данные
			type:'POST', // тип запроса
			success:function(data){
				if( data ) {
					$('#true_loadmore').text('Загрузить ещё').before(data); // вставляем новые посты
					current_page++; // увеличиваем номер страницы на единицу
					if (current_page == max_pages) $("#true_loadmore").remove(); // если последняя страница, удаляем кнопку
				} else {
					$('#true_loadmore').remove(); // если мы дошли до последней страницы постов, скроем кнопку
				}
			}
		});
	});
});

$('.js-slider-fs').slick({
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
});

document.addEventListener('DOMContentLoaded', function(){
	// проверка для полей "Сколько % юзеров" - сумма должна быть ровно 100
	function checkSum() {
		let sum = 0;

		let select = document.querySelectorAll('div[data-name="ref_links"] .acf-table tbody .acf-row:not(:last-child) td[data-name="user_proc"] select');
		select.forEach(function(el){
			sum += +(el.value);
		});
		return sum;
	}

	let formSubmit = document.getElementById('post');
	if(formSubmit){
		formSubmit.addEventListener('submit', function(e){
			let sum = checkSum();

			if (sum != 100) {
				e.preventDefault();
				e.stopPropagation();
				alert('"Сколько % юзеров" - сумма должна быть ровно 100');
				changeSum();
				return false;
			}
		});
	}


	function changeSum() {
		let sum = checkSum();
		let max_num = 100 - sum;
		let select = document.querySelectorAll('div[data-name="ref_links"] .acf-table tbody .acf-row td[data-name="user_proc"] select');
		select.forEach(function(el){
			let selectVal = +el.value;
			for (let el_item of el) {
				let new_select = el_item;
				new_select.removeAttribute('hidden');
				if (max_num > 0) {
					if (+new_select.value > selectVal+max_num) {
						new_select.setAttribute('hidden', true);
					}
				} else {
					if (+new_select.value> selectVal) {
						new_select.setAttribute('hidden', true);
					}
				}

			}
		});
	}

	let acf_button = document.querySelector('div[data-name="ref_links"] .acf-actions .acf-button');
	if(acf_button){
		acf_button.addEventListener('click', function () {
			changeSum();
		});
	}

	let new_select = document.querySelector('div[data-name="ref_links"] .acf-table tbody .acf-row td[data-name="user_proc"] select');

	window.addEventListener('click', function (event) {
		let target = event.target;
		if (target.nodeName == 'SELECT') {
			target.addEventListener('click', function () {
				changeSum();
			});
		}
		if (target.dataset.event == 'remove-row') {
			changeSum();
		}
	});
	changeSum();

	let readonly_input = document.querySelector('div[data-name="click_count"] input');
	if(readonly_input){
		readonly_input.setAttribute('readonly', 'true');
	}
});

/*////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////        LAZY LOAD      //////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
var _extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t},_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};!function(t,e){"object"===("undefined"==typeof exports?"undefined":_typeof(exports))&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):t.LazyLoad=e()}(this,function(){"use strict";function t(t,e,n){var o=e._settings;!n&&i(t)||(C(o.callback_enter,t),R.indexOf(t.tagName)>-1&&(N(t,e),I(t,o.class_loading)),E(t,e),a(t),C(o.callback_set,t))}var e={elements_selector:"img",container:document,threshold:300,thresholds:null,data_src:"src",data_srcset:"srcset",data_sizes:"sizes",data_bg:"bg",class_loading:"loading",class_loaded:"loaded",class_error:"error",load_delay:0,callback_load:null,callback_error:null,callback_set:null,callback_enter:null,callback_finish:null,to_webp:!1},n=function(t){return _extends({},e,t)},o=function(t,e){return t.getAttribute("data-"+e)},r=function(t,e,n){var o="data-"+e;null!==n?t.setAttribute(o,n):t.removeAttribute(o)},a=function(t){return r(t,"was-processed","true")},i=function(t){return"true"===o(t,"was-processed")},s=function(t,e){return r(t,"ll-timeout",e)},c=function(t){return o(t,"ll-timeout")},l=function(t){return t.filter(function(t){return!i(t)})},u=function(t,e){return t.filter(function(t){return t!==e})},d=function(t,e){var n,o=new t(e);try{n=new CustomEvent("LazyLoad::Initialized",{detail:{instance:o}})}catch(t){(n=document.createEvent("CustomEvent")).initCustomEvent("LazyLoad::Initialized",!1,!1,{instance:o})}window.dispatchEvent(n)},f=function(t,e){return e?t.replace(/\.(jpe?g|png)/gi,".webp"):t},_="undefined"!=typeof window,v=_&&!("onscroll"in window)||/(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),g=_&&"IntersectionObserver"in window,h=_&&"classList"in document.createElement("p"),b=_&&function(){var t=document.createElement("canvas");return!(!t.getContext||!t.getContext("2d"))&&0===t.toDataURL("image/webp").indexOf("data:image/webp")}(),m=function(t,e,n,r){for(var a,i=0;a=t.children[i];i+=1)if("SOURCE"===a.tagName){var s=o(a,n);p(a,e,s,r)}},p=function(t,e,n,o){n&&t.setAttribute(e,f(n,o))},y=function(t,e){var n=b&&e.to_webp,r=o(t,e.data_src),a=o(t,e.data_bg);if(r){var i=f(r,n);t.style.backgroundImage='url("'+i+'")'}if(a){var s=f(a,n);t.style.backgroundImage=s}},w={IMG:function(t,e){var n=b&&e.to_webp,r=e.data_srcset,a=t.parentNode;a&&"PICTURE"===a.tagName&&m(a,"srcset",r,n);var i=o(t,e.data_sizes);p(t,"sizes",i);var s=o(t,r);p(t,"srcset",s,n);var c=o(t,e.data_src);p(t,"src",c,n)},IFRAME:function(t,e){var n=o(t,e.data_src);p(t,"src",n)},VIDEO:function(t,e){var n=e.data_src,r=o(t,n);m(t,"src",n),p(t,"src",r),t.load()}},E=function(t,e){var n=e._settings,o=t.tagName,r=w[o];if(r)return r(t,n),e._updateLoadingCount(1),void(e._elements=u(e._elements,t));y(t,n)},I=function(t,e){h?t.classList.add(e):t.className+=(t.className?" ":"")+e},L=function(t,e){h?t.classList.remove(e):t.className=t.className.replace(new RegExp("(^|\\s+)"+e+"(\\s+|$)")," ").replace(/^\s+/,"").replace(/\s+$/,"")},C=function(t,e){t&&t(e)},O=function(t,e,n){t.addEventListener(e,n)},k=function(t,e,n){t.removeEventListener(e,n)},x=function(t,e,n){O(t,"load",e),O(t,"loadeddata",e),O(t,"error",n)},A=function(t,e,n){k(t,"load",e),k(t,"loadeddata",e),k(t,"error",n)},z=function(t,e,n){var o=n._settings,r=e?o.class_loaded:o.class_error,a=e?o.callback_load:o.callback_error,i=t.target;L(i,o.class_loading),I(i,r),C(a,i),n._updateLoadingCount(-1)},N=function(t,e){var n=function n(r){z(r,!0,e),A(t,n,o)},o=function o(r){z(r,!1,e),A(t,n,o)};x(t,n,o)},R=["IMG","IFRAME","VIDEO"],S=function(e,n,o){t(e,o),n.unobserve(e)},M=function(t){var e=c(t);e&&(clearTimeout(e),s(t,null))},j=function(t,e,n){var o=n._settings.load_delay,r=c(t);r||(r=setTimeout(function(){S(t,e,n),M(t)},o),s(t,r))},D=function(t){return t.isIntersecting||t.intersectionRatio>0},T=function(t){return{root:t.container===document?null:t.container,rootMargin:t.thresholds||t.threshold+"px"}},U=function(t,e){this._settings=n(t),this._setObserver(),this._loadingCount=0,this.update(e)};return U.prototype={_manageIntersection:function(t){var e=this._observer,n=this._settings.load_delay,o=t.target;n?D(t)?j(o,e,this):M(o):D(t)&&S(o,e,this)},_onIntersection:function(t){t.forEach(this._manageIntersection.bind(this))},_setObserver:function(){g&&(this._observer=new IntersectionObserver(this._onIntersection.bind(this),T(this._settings)))},_updateLoadingCount:function(t){this._loadingCount+=t,0===this._elements.length&&0===this._loadingCount&&C(this._settings.callback_finish)},update:function(t){var e=this,n=this._settings,o=t||n.container.querySelectorAll(n.elements_selector);this._elements=l(Array.prototype.slice.call(o)),!v&&this._observer?this._elements.forEach(function(t){e._observer.observe(t)}):this.loadAll()},destroy:function(){var t=this;this._observer&&(this._elements.forEach(function(e){t._observer.unobserve(e)}),this._observer=null),this._elements=null,this._settings=null},load:function(e,n){t(e,this,n)},loadAll:function(){var t=this;this._elements.forEach(function(e){t.load(e)})}},_&&function(t,e){if(e)if(e.length)for(var n,o=0;n=e[o];o+=1)d(t,n);else d(t,e)}(U,window.lazyLoadOptions),U});
document.addEventListener('DOMContentLoaded', function(){
    var myLazyLoad = new LazyLoad();
});*/
